import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		cookieIsSet: false,
		googleMapsIsAllowed: false,
		youtubeIsAllowed: false
	},
	getters: {
		cookieIsSet: (state) => state.cookieIsSet,
		googleMapsIsAllowed: (state) => state.googleMapsIsAllowed,
		youtubeIsAllowed: (state) => state.youtubeIsAllowed
	},
	mutations: {
		onSetCookie(state) {
			state.cookieIsSet = true
		},
		onAllowGoogleMaps(state) {
			state.googleMapsIsAllowed = true
		},
		onDisallowGoogleMaps(state) {
			state.googleMapsIsAllowed = false
		},
		onAllowYoutube(state) {
			state.youtubeIsAllowed = true
		},
		onDisallowYoutube(state) {
			state.youtubeIsAllowed = false
		}
	},
	actions: {},
	modules: {}
})
